import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { AccountService, EventManager } from 'src/app/core';
declare var $;
@Component({
  selector: 'add-icon-notificaiton-popup',
  templateUrl: './icon-notificaiton-popup.component.html',
  styleUrls: ['./icon-notificaiton-popup.component.scss']
})
export class IconNotificationPopUpComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() eventBroadcast: string;
  @Input() sales;
  @Input() isShow: boolean = false;
  subscriptions?: Subscription[] = [];
  constructor(
    public formBuilder: FormBuilder,
    public eventManager: EventManager
  ) {

  }
  ngOnInit() {
    this.subscriptions = [
      this.eventManager.subscribe('open-icon', () => {
        this.isShow = true;
      }),
      this.eventManager.subscribe('close-icon', () => {
        this.close();
      })
    ];
    
  }
  ngOnDestroy(): void {
    this.eventManager.destroys(this.subscriptions);
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      $(".icon-push").click((e) => {
        this.eventManager.broadcast({
          name: this.eventBroadcast,
          content: {
            value: e.target.innerHTML
          }
        });
        this.isShow = false;
      });
    }, 1000)
  }
  close() {
    this.isShow = false;
  }
  chooseCategory(category) {
    let scrollToValue = 0
    switch (category ) {
      case 1:
        scrollToValue = 0;
      break;
      case 2:
        scrollToValue = 250;
      break;
      case 3:
        scrollToValue = 500;
      break;
      case 4:
        scrollToValue = 750;
      break;
      case 5:
        scrollToValue = 950;
      break;
      case 6:
        scrollToValue = 1200;
      break;
      case 7:
        scrollToValue = 1450;
      break;
      case 8:
        scrollToValue = 1700;
      break;
      case 9:
        scrollToValue = 2050;
      break;
    }
    $('#listIcon')[0].scrollTo(0, scrollToValue);
  }
}
